export default [{
    text: 'Центральная',
    value: 'central'
}, {
    text: 'Автономная',
    value: 'autonomous'
}];
